import axios from './configAxios';

export const postToSendCode = async (requestData) => {
  return await axios.post('send_code/', requestData);
};
